import React, { ReactElement } from 'react';
import { FilterTag, FilterTagGroup } from 'slovlex-idsk-react-components';
import { PravoEuFilter } from '../../../model/PravoEuFilter';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import { putDatumyOdDoToArray } from '../../../function/putDatumyOdDoToArray';

interface Props {
  filter: PravoEuFilter,
  onUpdateField: SafeParameterSetter<PravoEuFilter>,
  classes?: string
  /**
   * Pre desktop. V mobilnom modale ma tlacidlo na starosti MobileFilterModal,
   * takze tam sa nechava nevyplnene.
   */
  onClearFilters?: () => void
}

const FilterTagsComponent = ({
  filter,
  onUpdateField,
  classes,
  onClearFilters = null,
}: Props): ReactElement => (
  <FilterTagGroup className={classes} onClearFilters={onClearFilters}>
    <FilterTag
      title="Hľadaný výraz"
      data={filter.hladanyVyraz}
      onClear={() => {
        onUpdateField('hladanyVyraz', '');
      }}
    />
    <FilterTag
      title="Celex"
      data={filter.celex}
      onClear={() => {
        onUpdateField('celex', '');
      }}
    />
    <FilterTag
      title="Rok uverejnenia"
      data={filter.rokUverejnenia !== undefined ? `${(filter.rokUverejnenia)}` : undefined}
      onClear={() => {
        onUpdateField('rokUverejnenia', undefined);
      }}
    />
    <FilterTag
      title="EuroVoc"
      data={filter.eurovoc}
      onClear={() => {
        onUpdateField('eurovoc', '');
      }}
    />
    <FilterTag
      title="Typ"
      data={filter.type?.nazov}
      onClear={() => {
        onUpdateField('type', null);
      }}
    />
    <FilterTag
      title="Autor"
      data={filter.autor?.nazov}
      onClear={() => {
        onUpdateField('autor', null);
      }}
    />
    <FilterTag
      title="Zmluva"
      data={filter.zmluva}
      onClear={() => onUpdateField('zmluva', undefined)}
    />
    <FilterTag
      title="Dátum uverejnenia"
      data={putDatumyOdDoToArray(filter.datumUverejneniaOd, filter.datumUverejneniaDo)}
      onClear={(title) => {
        if (title.startsWith('od')) {
          onUpdateField('datumUverejneniaOd', undefined);
        }
        if (title.startsWith('do')) {
          onUpdateField('datumUverejneniaDo', undefined);
        }
      }}
    />
    <FilterTag
      title="Dátum schválenia"
      data={putDatumyOdDoToArray(filter.datumSchvaleniaOd, filter.datumSchvaleniaDo)}
      onClear={(title) => {
        if (title.startsWith('od')) {
          onUpdateField('datumSchvaleniaOd', undefined);
        }
        if (title.startsWith('do')) {
          onUpdateField('datumSchvaleniaDo', undefined);
        }
      }}
    />
    <FilterTag
      title="Dátum účinnosti od"
      data={putDatumyOdDoToArray(filter.datumUcinnostiOdOd, filter.datumUcinnostiOdDo)}
      onClear={(title) => {
        if (title.startsWith('od')) {
          onUpdateField('datumUcinnostiOdOd', undefined);
        }
        if (title.startsWith('do')) {
          onUpdateField('datumUcinnostiOdDo', undefined);
        }
      }}
    />
    <FilterTag
      title="Dátum účinnosti do"
      data={putDatumyOdDoToArray(filter.datumUcinnostiDoOd, filter.datumUcinnostiDoDo)}
      onClear={(title) => {
        if (title.startsWith('od')) {
          onUpdateField('datumUcinnostiDoOd', undefined);
        }
        if (title.startsWith('do')) {
          onUpdateField('datumUcinnostiDoDo', undefined);
        }
      }}
    />
    <FilterTag
      title="Dátum uzávierky"
      data={putDatumyOdDoToArray(filter.datumUzavierkyOd, filter.datumUzavierkyDo)}
      onClear={(title) => {
        if (title.startsWith('od')) {
          onUpdateField('datumUzavierkyOd', undefined);
        }
        if (title.startsWith('do')) {
          onUpdateField('datumUzavierkyDo', undefined);
        }
      }}
    />
    <FilterTag
      title="Dátum transpozície"
      data={putDatumyOdDoToArray(filter.datumTranspozicieOd, filter.datumTranspozicieDo)}
      onClear={(title) => {
        if (title.startsWith('od')) {
          onUpdateField('datumTranspozicieOd', undefined);
        }
        if (title.startsWith('do')) {
          onUpdateField('datumTranspozicieDo', undefined);
        }
      }}
    />
  </FilterTagGroup>
);

export default FilterTagsComponent;
